/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Document_Credit_Note_3plInputs */

const en_inbound_document_credit_note_3pl = /** @type {(inputs: Inbound_Document_Credit_Note_3plInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit note of the warehouse`)
};

/**
* | output |
* | --- |
* | "Credit note of the warehouse" |
*
* @param {Inbound_Document_Credit_Note_3plInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_document_credit_note_3pl = /** @type {((inputs?: Inbound_Document_Credit_Note_3plInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Document_Credit_Note_3plInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_document_credit_note_3pl(inputs)
});